import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PdfViewerCard from "../../PdfViewerCard";
import temas from "./pythonTemas";
import "../../incidentes.css";

const PythonTema = () => {
  const { numero } = useParams();
  const tema = temas[Number(numero) - 1];

  if (!tema) {
    return (
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema no encontrado</h1>
        </div>
      </Container>
    );
  }

  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/${tema.pdf}`;

  return (
    <Container fluid className="background-containerr">
      <div className="orgproc-header">
        <h1 className="orgproc-heading">{tema.titulo}</h1>
      </div>
      <PdfViewerCard pdfUrl={pdfUrl} titulo={tema.titulo} />
    </Container>
  );
};

export default PythonTema;
